<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Военная составляющая игры / Противостояние между Богами Хаоса и игроками, Союзами, частями света</h3>
		</header>
		<p>...</p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiOpisWars4',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>